import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { CognitoAuthService } from '@techspert-io/auth';
import { RAY_GUN, Raygun } from './tokens';

@Injectable()
export class RaygunErrorHandler implements ErrorHandler {
  constructor(
    @Inject(RAY_GUN) private raygun: Raygun,
    private cognitoAuthService: CognitoAuthService
  ) {}

  handleError(e: Error): void {
    console.error(e);

    const userId = this.cognitoAuthService.loggedInUser
      ? this.cognitoAuthService.loggedInUser.user_id
      : null;

    if (e instanceof HttpErrorResponse) {
      return this.raygun('send', {
        error: new Error(e.message),
        customData: {
          httpResponse: e,
          userId,
        },
      });
    }

    if (e instanceof Error) {
      if (e.message.startsWith('ResizeObserver')) {
        return;
      }

      return this.raygun('send', {
        error: e,
        customData: { userId },
      });
    }

    return this.raygun('send', {
      error: new Error('Unknown Error'),
      customData: {
        unknownError: e,
        userId,
      },
    });
  }
}
